import React from 'react';
import { siteConfig } from '../config/siteConfig';
import { Star } from 'lucide-react';

export const Services = () => {
  const { services } = siteConfig;

  return (
    <section id="servicios" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[hsl(var(--primary))] mb-4">
            Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-6">
            Soluciones integrales para proteger tu patrimonio y el de tu familia
          </p>
          <div className="w-20 h-1 bg-[hsl(var(--accent))] mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className={`group bg-white rounded-xl overflow-hidden transition-all duration-300 ${
                service.featured
                  ? 'shadow-xl hover:shadow-2xl border-2 border-[hsl(var(--accent))]'
                  : 'shadow-md hover:shadow-2xl border border-gray-100'
              }`}
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.imageUrl}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--primary))] to-transparent opacity-60" />
                {service.featured && (
                  <div className="absolute top-4 left-4 inline-flex items-center gap-2 rounded-full bg-[hsl(var(--accent))] px-4 py-2 text-sm font-semibold text-[hsl(var(--primary))] shadow-lg">
                    <Star className="h-4 w-4 fill-current" />
                    <span>Más solicitado</span>
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[hsl(var(--primary))] mb-3 line-clamp-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
